"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ProvidersList_1 = __importDefault(require("./ProvidersList"));
var ui_components_1 = require("@l2p/ui-components");
var apps_shared_1 = require("@l2p/apps-shared");
var apps_shared_2 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var navigation_1 = require("next/navigation");
var BlockWithGames_1 = __importDefault(require("./BlockWithGames"));
var SELECTED_PROVIDER = 'selected_provider';
var SearchByProvider = function (_a) {
    var gameCardPlaceholder = _a.gameCardPlaceholder, correctionCoefficient = _a.correctionCoefficient;
    var _b = (0, swr_hooks_1.useCache)(), getDataFromCache = _b.getDataFromCache, setDataToCache = _b.setDataToCache;
    var _c = (0, react_1.useState)(getDataFromCache(SELECTED_PROVIDER) || null), selectedProvider = _c[0], setSelectedProvider = _c[1];
    var _d = (0, swr_hooks_1.useProviders)(), data = _d.data, isLoading = _d.isLoading;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var generateUrlWithLang = (0, apps_shared_2.useGenerateUrlWithLang)();
    var router = (0, navigation_1.useRouter)();
    var onClickProviderInDesktop = (0, react_1.useCallback)(function (provider) {
        if (String(selectedProvider === null || selectedProvider === void 0 ? void 0 : selectedProvider.slug) === (provider === null || provider === void 0 ? void 0 : provider.slug)) {
            setSelectedProvider(null);
            setDataToCache(SELECTED_PROVIDER, null);
        }
        else {
            setSelectedProvider(provider);
            setDataToCache(SELECTED_PROVIDER, provider);
        }
    }, [setSelectedProvider, selectedProvider, setDataToCache]);
    var onClickProviderInMobile = (0, react_1.useCallback)(function (provider) {
        var _a;
        router.push(generateUrlWithLang("/providers/".concat((_a = provider === null || provider === void 0 ? void 0 : provider.slug) === null || _a === void 0 ? void 0 : _a.toLowerCase())));
    }, [generateUrlWithLang, router]);
    var onClickProvider = (0, react_1.useCallback)(function (provider) {
        if (breakpoints.mobile || breakpoints.tablet)
            onClickProviderInMobile(provider);
        else
            onClickProviderInDesktop(provider);
    }, [
        breakpoints.mobile,
        breakpoints.tablet,
        onClickProviderInDesktop,
        onClickProviderInMobile,
    ]);
    if (!data || isLoading)
        return react_1.default.createElement(ui_components_1.LoadingWithContainer, null);
    if (Object.keys(breakpoints).length === 0)
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement(ProvidersList_1.default, { selectedProviderSlug: selectedProvider === null || selectedProvider === void 0 ? void 0 : selectedProvider.slug, onItemClick: onClickProvider, providers: data }),
        react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(ui_components_1.LoadingWithContainer, null) }, !breakpoints.mobile && !breakpoints.tablet && (react_1.default.createElement(BlockWithGames_1.default, { provider: selectedProvider, gameCardPlaceholder: gameCardPlaceholder, columnsCount: 6, correctionCoefficient: correctionCoefficient })))));
};
exports.default = react_1.default.memo(SearchByProvider);
